/**
 * [INPUT]: 依赖 react；依赖 ../pipeline/mediapipe 的 getModelStatus / subscribeModelStatus / ModelStatus
 * [OUTPUT]: 对外提供 useModelStatus() hook —— 订阅模型加载状态，驱动 UI 分阶段反馈
 * [POS]: apps/web/hooks 的 React 绑定层，桥接 pipeline 纯模块与组件
 * [PROTOCOL]: 变更时更新本头部，然后检查 ../CLAUDE.md
 */
import { useEffect, useState } from 'react'
import { getModelStatus, subscribeModelStatus, type ModelStatus } from '../pipeline/mediapipe'

/** 订阅 FaceLandmarker 加载状态；惰性初值取自模块单例，避免首帧闪烁。 */
export function useModelStatus(): ModelStatus {
  const [status, setStatus] = useState<ModelStatus>(getModelStatus)
  useEffect(() => subscribeModelStatus(setStatus), [])
  return status
}